import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row checkbox-list align-items-center mb-n3" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["id", "checked", "onInput", "value"]
const _hoisted_4 = { class: "h-2line d-flex mt-1 align-items-center justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectableOptions, ({option, selected}) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "col-6 col-md-4 col-lg-3",
        key: option.value
      }, [
        _createElementVNode("label", {
          class: _normalizeClass(["form-check-label checkbox-list-item mt-2 mb-3 ps-0 pe-0 form-label", {active: selected}]),
          for: _ctx.optionValues[option.value]
        }, [
          (option.icon)
            ? (_openBlock(), _createBlock(_component_SvgIcon, {
                key: 0,
                class: "large-icon",
                "symbol-data": _ctx.icons[option.icon]
              }, null, 8, ["symbol-data"]))
            : _createCommentVNode("", true),
          _createElementVNode("input", {
            type: "checkbox",
            id: _ctx.optionValues[option.value],
            checked: selected,
            onInput: () => _ctx.checkedChange(option, !selected),
            value: option.value
          }, null, 40, _hoisted_3),
          _createElementVNode("span", _hoisted_4, _toDisplayString(option.label), 1)
        ], 10, _hoisted_2)
      ]))
    }), 128))
  ]))
}